import { createFileRoute } from '@tanstack/react-router';
import { SupportTab } from '../../pages/dashboard/support/SupportTab';

export const Route = createFileRoute('/dashboard/support')({ component: SupportTab });
